import { Tag } from '../components/tag';
import { PromotionTypes } from './const';

export const getPromotionsTypeName = (type: PromotionTypes) => {
    switch (type) {
        case 'in_store':
            return 'In store';
        case 'coupon':
            return 'Coupon';
    }
};

export const getPromotionsTypeExistingTitle = (
    type: PromotionTypes | undefined
) => {
    if (type === 'coupon') return 'Coupon #';
    return 'In store promotion #';
};

export const getPromotionsTypeNewTitle = (type: PromotionTypes | undefined) => {
    if (type === 'coupon') return 'New Coupon';
    return 'New In store promotion';
};

export const getPromotionsTypeTitle = (type: PromotionTypes | undefined) => {
    if (type === 'coupon') return 'Coupons';
    return 'In store promotions';
};

export function PromotionTypeTag({ type }: { type: PromotionTypes }) {
    const name = getPromotionsTypeName(type);
    switch (type) {
        case 'in_store':
            return <Tag variant="volcano">{name}</Tag>;
        case 'coupon':
            return <Tag variant="gold">{name}</Tag>;
    }
}
